import React from 'react';
export function Header() {
  return <header className="bg-white border-b border-gray-200" data-id="element-54">
      <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center" data-id="element-55">
        <div className="flex items-center" data-id="element-56">
          <div className="text-orange-600 font-bold text-2xl mr-8" data-id="element-57">HubSpot</div>
          <nav className="hidden md:flex" data-id="element-58">
            <ul className="flex space-x-6" data-id="element-59">
              <li data-id="element-60">
                <a href="#" className="text-gray-600 hover:text-gray-900" data-id="element-61">
                  Software
                </a>
              </li>
              <li data-id="element-62">
                <a href="#" className="text-gray-600 hover:text-gray-900" data-id="element-63">
                  Pricing
                </a>
              </li>
              <li data-id="element-64">
                <a href="#" className="text-gray-600 hover:text-gray-900" data-id="element-65">
                  Resources
                </a>
              </li>
              <li data-id="element-66">
                <a href="#" className="text-gray-600 hover:text-gray-900" data-id="element-67">
                  Partners
                </a>
              </li>
              <li data-id="element-68">
                <a href="#" className="text-gray-600 hover:text-gray-900" data-id="element-69">
                  About
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <div className="flex items-center space-x-4" data-id="element-70">
          <a href="#" className="text-gray-600 hover:text-gray-900" data-id="element-71">
            Log in
          </a>
          <a href="#" className="bg-orange-600 text-white px-4 py-2 rounded-md hover:bg-orange-700" data-id="element-72">
            Get started free
          </a>
        </div>
      </div>
    </header>;
}